import { render, staticRenderFns } from "./ConsumeTypeInfoCard.vue?vue&type=template&id=4fae4d94&scoped=true"
import script from "./ConsumeTypeInfoCard.vue?vue&type=script&lang=js"
export * from "./ConsumeTypeInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae4d94",
  null
  
)

export default component.exports